import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import { Route, useNavigate, useLocation } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import Illustration from "../../assets/images/image-2.png";
import { SagaActions } from "../../redux/actionTypes";

import { AuthPageWrapper } from "./auth.styled";
import FooterOne from "../../components/footer/footerOne";

import { resendSignUpOtpReq } from "../../api/auth/otpRequests";
import { loginWithMailReq } from "../../api/auth/loginRequest";

import SignupInfoBlock from "./signupComponents/signupInfoBlock";
import RenderIf from "../../components/renderIf";
import OtpBlock from "./signupComponents/otpBlock";
import SmsOtpBlock from "./signupComponents/smsOtpBlock";
import CreatePswdBlock from "./signupComponents/createPswdBlock";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { ROUTE_NAMES } from "../../constants/routeNames";

export const SignupPage = () => {
  const navigation = useNavigate();
  const location = useLocation();
  const data = location.state;
  const Dispatch = useDispatch();
  const [authStage, setauthStage] = useState("signup");
  const [userMailId, setuserMailId] = useState("");
  const [userId, setuserId] = useState<any>();
  localStorage.setItem("@loggedDate", `${dayjs().format("MMMM DD, YYYY")}`);
  const _userID = localStorage.getItem("@userId") || 0;

  const resendOtpFun = async (typesIs: string) => {
    try {
      const res = await resendSignUpOtpReq({
        userId: Number(_userID),
        type: typesIs,
      });
      Dispatch({
        type: SagaActions.INFO,
        payload: {
          env: "dev",
          message: res?.message,
          fileName: "signupPage",
          methodName: "resendOtpFun",
          type: "info",
        },
      });
      toast.success(res?.message);
    } catch (error: any) {
      console.log(error, "loginPage->LoginPage->resendOtpFun error");
      toast.error(error?.errorMsg);
      Dispatch({
        type: SagaActions.ERROR,
        payload: {
          env: "dev",
          message: error?.errorMsg,
          fileName: "signupPage",
          methodName: "resendOtpFun",
          type: "error",
        },
      });
    }
  };

  const loginFun = async (data: any) => {
    try {
      const body = {
        emailIs: data.emailIs,
        passwordIs: data.passwordIs,
      };
      const res = await loginWithMailReq(body);
      setuserId(res.data.id);
      toast.success(res?.message);
      Dispatch({
        type: SagaActions.INFO,
        payload: {
          env: "dev",
          message: res?.message,
          fileName: "signupPage",
          methodName: "loginFun",
          type: "info",
        },
      });
      navigation(`${ROUTE_NAMES.Home}/${ROUTE_NAMES.Dashboard}`);
    } catch (error: any) {
      console.log(error, "loginPage->LoginPage->resendOtpFun error");
      toast.error(error?.errorMsg);
      Dispatch({
        type: SagaActions.ERROR,
        payload: {
          env: "dev",
          message: error?.errorMsg,
          fileName: "signupPage",
          methodName: "loginFun",
          type: "error",
        },
      });
    }
  };

  const _onPress = ({ key, data }: { key: string; data?: any }) => {
    const fun: any = {
      sendOtp: (data: any) => {
        setauthStage("otp");
      },
      verifyMailOtp: (data: any) => {
        setauthStage("smsOtp");
      },
      resendOtp: (data: any) => resendOtpFun(data?.typesIs || "Mail"),
      verifySMSOtp: (data: any) => {
        setauthStage("password");
      },
      login: (data: any) => {
        setauthStage("login");
      },
      authenticate: (data: any) => {
        loginFun(data);
        // setauthStage("signup");
        // localStorage.setItem("@auth", "qwertyuiop");
        // window.location.reload();
      },
      null: () => {},
    };
    fun[key](data);
  };
  return (
    <AuthPageWrapper>
      <Container fluid className=" flex-grow-1">
        <Row className=" h-100">
          <Col
            lg={7}
            className="d-flex flex-column align-items-center justify-content-center pt-lg-5 pb-lg-2 "
          >
            <div className={`banner `}>
              <img src={Illustration} />
            </div>
          </Col>
          <Col lg={5} className=" border-info px-lg-5">
            <RenderIf isShow={authStage === "signup"}>
              <SignupInfoBlock
                onSubmit={(data: any) => {
                  _onPress({ key: "sendOtp", data });
                  setuserMailId(data.emailIs);
                }}
                forgotPassword={data ? data : false}
              />
            </RenderIf>
            <RenderIf isShow={authStage === "otp"}>
              <OtpBlock
                onSubmit={(data: any) =>
                  _onPress({ key: "verifyMailOtp", data })
                }
                onResendOtp={() =>
                  _onPress({ key: "resendOtp", data: { typesIs: "Mail" } })
                }
                otherData={{ email: userMailId }}
              />
            </RenderIf>
            <RenderIf isShow={authStage === "smsOtp"}>
              <SmsOtpBlock
                onSubmit={(data: any) =>
                  _onPress({ key: "verifySMSOtp", data })
                }
                onResendOtp={() =>
                  _onPress({ key: "resendOtp", data: { typesIs: "SMS" } })
                }
                otherData={{ email: userMailId }}
              />
            </RenderIf>
            <RenderIf isShow={authStage === "password"}>
              <CreatePswdBlock
                onSubmit={() => _onPress({ key: "login" })}
                forgotPassword={data ? data : false}
              />
            </RenderIf>
          </Col>
        </Row>
      </Container>
      <FooterOne />
    </AuthPageWrapper>
  );
};
